import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import { Skeleton } from '@verclam/ui-kit';
import type * as React from 'react';

const stageStyle = css`
	display: flex;
	justify-content: center;
	padding: 1.5rem;
	border-radius: ${theme.radii.xlarge};
	background-color: ${theme.colors.track};
`;

const pageStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.875rem;
	box-sizing: border-box;
	width: min(38rem, 100%);
	aspect-ratio: 210 / 297;
	padding: 8%;
	border-radius: 4px;
	background-color: ${theme.colors.surface};
`;

/** An A4 sheet of grey bars, in place of the document while it is read and laid out. */
const DocumentPageSkeleton: React.FC = () => {
	return (
		<div css={stageStyle} role="status" aria-busy="true" aria-label="Chargement du document">
			<div css={pageStyle}>
				<Skeleton width="40%" height="0.875rem" animation="wave" />
				<Skeleton height="0.625rem" animation="wave" />
				<Skeleton width="92%" height="0.625rem" animation="wave" />
				<Skeleton width="85%" height="0.625rem" animation="wave" />
				<Skeleton width="35%" height="0.875rem" animation="wave" />
				<Skeleton width="96%" height="0.625rem" animation="wave" />
				<Skeleton width="70%" height="0.625rem" animation="wave" />
			</div>
		</div>
	);
};

export default DocumentPageSkeleton;
